<script setup>
import QrcodeVue from 'qrcode.vue'

defineProps({
  value: {
    type: String,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  size: {
    type: Number,
    default: 220
  },
  level: {
    type: String,
    default: 'H',
    validator: (value) => ['L', 'M', 'Q', 'H'].includes(value)
  }
})
</script>

<template>
  <div class="modal-qr-code-card__wrap">
    <div class="modal-qr-code-card" :style="{ '--qr-code-size': `${size}px` }">
      <div class="modal-qr-code-card__media">
        <v-progress-circular v-if="loading" color="primary" indeterminate />
        <QrcodeVue v-else :value="value" :size="size" :level="level" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-qr-code-card__wrap {
  display: flex;
  justify-content: center;
}

.modal-qr-code-card {
  background: rgb(var(--v-theme-surface));
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 20px;
  width: calc(var(--qr-code-size) + 42px);
  max-width: 100%;
}

.modal-qr-code-card__media {
  align-items: center;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  width: 100%;
}

.modal-qr-code-card__media :deep(canvas) {
  display: block;
  height: 100% !important;
  width: 100% !important;
}

@media (max-width: 600px) {
  .modal-qr-code-card {
    padding: 16px;
    width: 100%;
  }
}
</style>
